import React from 'react';

function HolidayHomeworkEditor({ pageContent, uploading, uploadingField, addTableRow, deleteTableRow, updateTableRow, handleFileUpload }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>🎒 Holiday Homework</h3>
        {(pageContent.homeworkItems || []).map((h) => (
          <div key={h.id} style={{border:'1px solid #e2e8f0',padding:12,marginBottom:10}}>
            <input placeholder="Class" value={h.class || ''} onChange={(e) => updateTableRow('homeworkItems', h.id, 'class', e.target.value)} style={{width:100}} className="form-input" />
            <input placeholder="Holiday" value={h.holiday || ''} onChange={(e) => updateTableRow('homeworkItems', h.id, 'holiday', e.target.value)} style={{width:120}} className="form-input" />
            <textarea placeholder="Description" value={h.description || ''} onChange={(e) => updateTableRow('homeworkItems', h.id, 'description', e.target.value)} rows="2" className="form-input" />
            {h.file && <a href={h.file.url} target="_blank" rel="noopener noreferrer">📄 File</a>}
            <label className="upload-label">{uploading && uploadingField === `file_${h.id}` ? '⏳...' : '📎 Upload'}<input type="file" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleFileUpload('homeworkItems', h.id, e.target.files[0]); }} /></label>
            <button className="remove-btn" onClick={() => deleteTableRow('homeworkItems', h.id)}>🗑️</button>
          </div>
        ))}
        <button className="add-btn" onClick={() => addTableRow('homeworkItems', { class: '', holiday: '', description: '' })}>+ Add</button>
      </div>
    </div>
  );
}

export default HolidayHomeworkEditor;